import API from 'API';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Slider } from 'antd';
import Bubble from './Bubble';
import { isColliding, randomArr, randomInt } from './bubble_function';

const mockData = [
    // {
    //     id: 1,
    //     message: "Chúc hai bạn trăm năm hạnh phúc, luôn yêu thương và đồng hành cùng nhau suốt cuộc đời.",
    //     name: "Nguyễn Minh Anh",
    //     weight: 4
    // },
    // {
    //     id: 2,
    //     message: "Chúc tổ ấm mới của hai bạn luôn ngập tràn tiếng cười và niềm vui.",
    //     name: "Trần Hoàng Nam",
    //     weight: 4
    // },
    // {
    //     id: 3,
    //     message: "Mong rằng mỗi ngày bên nhau đều là một ngày hạnh phúc và ý nghĩa.",
    //     name: "Lê Thu Trang",
    //     weight: 4
    // },
    // {
    //     id: 4,
    //     message: "Chúc hai bạn sớm đón thêm thành viên mới và luôn viên mãn trong cuộc sống.",
    //     name: "Phạm Quỳnh Như",
    //     weight: 4
    // },
    // {
    //     id: 5,
    //     message: "Chúc tình yêu của hai bạn luôn bền chặt như ngày đầu mới yêu.",
    //     name: "Đỗ Thành Công",
    //     weight: 4
    // },
    // {
    //     id: 6,
    //     message: "Mong rằng mọi khó khăn sẽ chỉ làm tình cảm hai bạn thêm gắn bó.",
    //     name: "Vũ Ngọc Mai",
    //     weight: 4
    // },
    // {
    //     id: 7,
    //     message: "Chúc hai bạn xây dựng được một gia đình hạnh phúc và thành công.",
    //     name: "Bùi Gia Hưng",
    //     weight: 4
    // },
    // {
    //     id: 8,
    //     message: "Chúc cô dâu chú rể mãi mãi yêu thương, sẻ chia và thấu hiểu nhau.",
    //     name: "Ngô Thị Lan",
    //     weight: 4
    // },
    // {
    //     id: 9,
    //     message: "Chúc hai bạn có một hành trình hôn nhân thật rực rỡ và đáng nhớ.",
    //     name: "Trịnh Quốc Bảo",
    //     weight: 4
    // },
    // {
    //     id: 10,
    //     message: "Mong rằng ngôi nhà của hai bạn luôn đầy ắp tiếng cười và yêu thương.",
    //     name: "Phan Mỹ Linh",
    //     weight: 4
    // },
    // {
    //     id: 11,
    //     message: "Chúc hai bạn nắm tay nhau đi qua mọi chặng đường của cuộc sống.",
    //     name: "Hoàng Anh Tuấn",
    //     weight: 4
    // },
    // {
    //     id: 12,
    //     message: "Chúc tình yêu của hai bạn luôn ngọt ngào và bền lâu theo năm tháng.",
    //     name: "Lý Khánh Vy",
    //     weight: 4
    // },
    // {
    //     id: 13,
    //     message: "Chúc cô dâu chú rể mãi hạnh phúc và thành công trong sự nghiệp lẫn cuộc sống.",
    //     name: "Nguyễn Đức Huy",
    //     weight: 4
    // },
    // {
    //     id: 14,
    //     message: "Mong rằng hai bạn sẽ luôn là điểm tựa vững chắc cho nhau.",
    //     name: "Đặng Thảo Nguyên",
    //     weight: 4
    // },
    // {
    //     id: 15,
    //     message: "Chúc hai bạn có một cuộc sống hôn nhân viên mãn và trọn vẹn yêu thương.",
    //     name: "Mai Trung Kiên",
    //     weight: 4
    // },
    // {
    //     id: 16,
    //     message: "Chúc hai bạn mãi giữ được sự tin tưởng và chân thành trong tình yêu.",
    //     name: "Trương Hải Yến",
    //     weight: 4
    // },
    // {
    //     id: 17,
    //     message: "Mong rằng mọi ước mơ chung của hai bạn đều trở thành hiện thực.",
    //     name: "Phạm Văn Long",
    //     weight: 4
    // },
    // {
    //     id: 18,
    //     message: "Chúc hai bạn luôn đồng lòng, đồng hành và đồng cảm trong mọi việc.",
    //     name: "Nguyễn Thị Hồng",
    //     weight: 4
    // },
    // {
    //     id: 19,
    //     message: "Chúc hôn lễ viên mãn và cuộc sống sau này luôn ngập tràn hạnh phúc.",
    //     name: "Lê Quang Vinh",
    //     weight: 4
    // },
    // {
    //     id: 20,
    //     message: "Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi.",
    //     name: "Đinh Ngọc Ánh",
    //     weight: 4
    // },
    // {
    //     id: 21,
    //     message: "Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi. Chúc hai bạn trọn đời bên nhau, yêu thương và sẻ chia mãi mãi.",
    //     name: "Đinh Ngọc Ánh",
    //     weight: 4
    // },
];

export default function ShowWeddingWishes() {
    const [queueWish, setQueueWish] = useState(null);
    const [weddingWishes, setWeddingWishes] = useState(mockData);
    const [bubbleFontSize, setBubbleFontSize] = useState(() => {
        try {
            const saved = localStorage.getItem("bubbleFontSize");
            const parsed = Number(saved);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : 16;
        } catch (error) {
            return 16;
        }
    });
    const [showFontSlider, setShowFontSlider] = useState(false);
    const divRef = useRef();
    const hideSliderTimeoutRef = useRef(null);
    const globalRef = useRef({
        needToUpdate: true, updated: true,
    });

    const showSliderTemporarily = useCallback(() => {
        setShowFontSlider(true);
        if (hideSliderTimeoutRef.current) {
            clearTimeout(hideSliderTimeoutRef.current);
        }
        hideSliderTimeoutRef.current = setTimeout(() => {
            setShowFontSlider(false);
        }, 2500);
    }, []);

    useEffect(() => {
        try {
            localStorage.setItem("bubbleFontSize", bubbleFontSize);
        } catch (error) {
            // ignore storage errors
        }
    }, [bubbleFontSize]);

    useEffect(() => () => {
        if (hideSliderTimeoutRef.current) {
            clearTimeout(hideSliderTimeoutRef.current);
        }
    }, []);

    // useEffect(() => {
    //     function fetchData() {
    //         const time = new Date().toLocaleTimeString("vi-VN", {
    //             hour: "2-digit",
    //             minute: "2-digit",
    //             second: "2-digit",
    //             hour12: false
    //         });
    //         setWeddingWishes(weddingWishes => [{
    //             id: Date.now(),
    //             message: `Lời chúc ${time}`,
    //             name: "Đinh Ngọc Ánh",
    //             weight: 4
    //         }, ...weddingWishes])
    //         globalRef.current.updated = true;
    //     }

    //     fetchData();
    //     const interval = setInterval(fetchData, 5000);

    //     return () => clearInterval(interval);
    // }, [])

    useEffect(() => {
        var sending = false;
        var maxId = null;
        function fetchData() {
            if (sending) return;
            sending = true;
            API.get(`show-wedding-wishes/${maxId ? `?id=${maxId}` : ""}`)
                .then(res => {
                    if (res.data.length > 0) {
                        for (const d of res.data) {
                            d.weight = 4;
                        }
                        setWeddingWishes(weddingWishes => [...res.data, ...weddingWishes]);
                        globalRef.current.updated = true;
                        maxId = res.data[0].id;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    sending = false;
                })
        }

        fetchData();
        const interval = setInterval(fetchData, 5000);

        return () => clearInterval(interval);
    }, [])

    const chooseWish = useCallback(() => {
        const notShowWishes = weddingWishes.filter(wish => !wish.bubble);
        if (notShowWishes.length === 0) {
            globalRef.current.needToUpdate = true;
            globalRef.current.updated = false;
            return;
        }

        globalRef.current.needToUpdate = false;
        globalRef.current.updated = false;
        const randomWish = randomArr(notShowWishes);
        setTimeout(() => {
            setQueueWish(randomWish);
        }, 500);
    }, [weddingWishes])

    useEffect(() => {
        if (globalRef.current.needToUpdate && globalRef.current.updated) {
            chooseWish();
        }
    }, [chooseWish])

    const onDoneAnimation = useCallback((id) => {
        setWeddingWishes(weddingWishes => {
            const index = weddingWishes.findIndex(wish => wish.id === id);
            const wish = weddingWishes[index];
            wish.bubble = null;
            globalRef.current.updated = true;
            weddingWishes[index] = { ...wish };
            return [...weddingWishes];
        })
    }, [])

    const doneQueue = useCallback((size) => {
        function findPosition() {
            let tried = 0;
            let bubble;
            do {
                bubble = {
                    x: randomInt(0, divRef.current.offsetWidth - size[0]),
                    y: divRef.current.offsetHeight,
                    width: size[0],
                    height: size[1],
                };

                tried++;
            } while (
                tried < 5 &&
                // eslint-disable-next-line
                weddingWishes.some(wish =>
                    wish.bubble && isColliding(bubble, wish.bubble, divRef.current.offsetHeight)
                )
            );

            if (tried === 5) {
                setTimeout(findPosition, 500);
                return;
            }

            bubble.startTime = Date.now();
            queueWish.bubble = bubble;
            setQueueWish(null);
            chooseWish();
        }

        findPosition();
    }, [weddingWishes, queueWish, chooseWish])

    return <>
        <div ref={divRef} style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            opacity: 0,
            pointerEvents: 'none',
        }}>
            {queueWish && <Bubble wish={queueWish} position={[0, 0]} doneQueue={doneQueue} fontSize={bubbleFontSize} />}
        </div>
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
        }}
            onMouseMove={showSliderTemporarily}
            onTouchStart={showSliderTemporarily}
        >
            <video
                autoPlay
                muted
                loop
                playsInline
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    objectFit: "cover",
                    zIndex: -1,
                    pointerEvents: "none",
                    opacity: 0.3,
                }}
            >
                <source src={process.env.PUBLIC_URL + "/img/slide.mp4"} type="video/mp4" />
            </video>
            <div style={{
                position: "fixed",
                left: "50%",
                bottom: 20,
                transform: "translateX(-50%)",
                width: 280,
                padding: "8px 14px 12px",
                background: "rgba(255, 255, 255, 0.92)",
                border: "1px solid rgba(193, 128, 154, 0.35)",
                borderRadius: 12,
                boxShadow: "0 8px 24px rgba(84, 39, 56, 0.2)",
                opacity: showFontSlider ? 1 : 0,
                pointerEvents: showFontSlider ? "auto" : "none",
                transition: "opacity 0.25s ease",
                zIndex: 2,
            }}>
                <div style={{
                    fontSize: 12,
                    color: "#6d3a4c",
                    marginBottom: 8,
                    textAlign: "center",
                    fontWeight: 600,
                }}>
                    Cỡ chữ lời chúc: {bubbleFontSize}px
                </div>
                <Slider
                    min={12}
                    max={26}
                    value={bubbleFontSize}
                    onChange={value => setBubbleFontSize(value)}
                />
            </div>
            {weddingWishes.filter(wish => wish.bubble).map(wish =>
                <Bubble
                    key={wish.id}
                    wish={wish}
                    position={[wish.bubble.x, wish.bubble.y]}
                    animation
                    onDoneAnimation={onDoneAnimation}
                    fontSize={bubbleFontSize}
                />
            )}
        </div>
    </>
}
